export class PaginatedRequest {
    page: string;
    pageSize: string;
    sorting: string;

    constructor(page: number, pageSize: number, sorting?: string) {
        this.page = (page-1).toString();
        this.pageSize = pageSize.toString();
        this.sorting = sorting;
    }
}


// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/models/paginated-request.ts